import React from "react";
import { rowColumn } from "../../../components/table/Table";
import { assignStatusPrimaryOptions, assignStatusSecondaryOptions } from "../../formObjects/application/assignStatusForm";
import { getFilterOptions } from "../../CommonFunctions";
export const presubmissionListTable = (currPath: string): rowColumn[] => [
  {
    label: "KIS ID",
    column: "id",
    type: "string",
    allowSort: true,
    sortOn: "Id",
  },
  {
    label: "First Name",
    column: "firstName",
    type: "string",
    allowSort: true,
    sortOn: "FirstName",
  },
  {
    label: "Last Name",
    column: "lastName",
    type: "string",
    allowSort: true,
    sortOn: "LastName",
  },
  {
    label: "Kindergarten",
    column: "fundedKinderName",
    type: "string",
    allowSort: true,
    sortOn: "FundedKinderName",
    body: (rowData) => {
      return <p className="m-0">{rowData.fundedKinderName === "Other" ? rowData.kindergartenNameOther : rowData.fundedKinderName}</p>;
    },
    isFilter: true,
    filterType: "search",
    filterKeyColumns: ["fundedKinderName", "kindergartenNameOther"],
  },
  {
    label: "Status",
    column: "statusComputed",
    type: "string",
    allowSort: true,
    sortOn: "StatusComputed",
    isFilter: true,
    filterType: "multiselect",
    filterElements: getFilterOptions(
      assignStatusPrimaryOptions.filter((x) => x.label === "Application"),
      {
        Application: assignStatusSecondaryOptions.Application?.filter((x) => x.label === "Presubmission"),
      }
    ),
  },
  {
    label: "Date Created",
    column: "dateCreated",
    type: "date",
    allowSort: true,
    sortOn: "DateCreated",
  },
  {
    label: "Actions",

    body: (rowData) => <a href={`${currPath}/${rowData.id}`}>View Details</a>,
  },
];
